import {
  type Modification,
  type ModificationGroupLimits,
  type ModificationsMap,
  type Modifiers,
  type SplitPortionAction,
} from '../../types';
import { getModificationsAfterSplit } from '../modifications';
import { generateDerivedModifiers } from './generate-derived-modifiers';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Gets the potential modifiers that would result from a split portion operation.
 */
export function getPotentialSplitPortionModifiers(
  params: GetPotentialSplitPortionModifiersParams,
): Modifiers {
  const {
    initialModifications,
    activeModifications,
    ingredientId,
    modificationGroupName,
    modificationLimits,
    allModificationsMap,
    action,
  } = params;

  const updatedActive = getModificationsAfterSplit({
    activeModifications,
    ingredientId,
    modificationGroupName,
    modificationLimits,
    allModificationsMap,
    action,
  });

  const modifiers = generateDerivedModifiers(initialModifications, updatedActive); // prettier-ignore

  return modifiers;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type GetPotentialSplitPortionModifiersParams = {
  ingredientId: string;
  modificationGroupName: string;
  initialModifications: Modification[];
  activeModifications: Modification[];
  modificationLimits: ModificationGroupLimits;
  allModificationsMap: ModificationsMap;
  action: SplitPortionAction;
};
